/**
 * Created by Mark on 18/12/2016.
 */

import ApplicationServices from './base-service.js';
import Constants from '../constants.js';
import Action    from '../application-actions.js';

class LicenceService {

    get(uid) {
        return ApplicationServices.call(Constants.GET_LICENCE , {uid:uid }).then(function(response){
            Action.update(Constants.ON_GOT_LICENCE , response);
        });
    };

    getCode() {
        return ApplicationServices.call(Constants.GET_BRAINTREE_CODE , { }).then(function(response){
            Action.update(Constants.GOT_BRAINTREE_CODE , response);
        });
    }

    braintreePayment(payload , packageData , userData){
        return ApplicationServices.call(Constants.MAKE_PAYMENT , {method:'braintree' , payload:payload , purchase:packageData , userData:userData }).then(function(response){
            return response;
        });

    }

    goCardlessPayment(packageData , userData){
        return ApplicationServices.call(Constants.MAKE_PAYMENT , {method:'goCardLess' , purchase:packageData , userData:userData }).then(function(response){
            return response;
        });
    }

    xeroPayment(packageData , userData){
        return ApplicationServices.call(Constants.MAKE_PAYMENT , {method:'invoice' , purchase:packageData , userData:userData }).then(function(response){
            return response;
        });
    }
}

export default new LicenceService();